export const ADVERTISEMENT_URL_CONTROL = 'advertisement-url-control';
export const ADVERTISEMENT_URL_REQUIRED_ERROR = 'ADVERTISEMENT_URL_REQUIRED_ERROR';
export const ADVERTISEMENT_URL_REQUIRED_MESSAGE = 'Advertisement URL is required field';

export const ADVERTISEMENT_DISPLAY_TIME_CONTROL = 'advertisement-display-time-control';
export const ADVERTISEMENT_DISPLAY_TIME_REQUIRED_ERROR = 'ADVERTISEMENT_DISPLAY_TIME_REQUIRED_ERROR';
export const ADVERTISEMENT_DISPLAY_TIME_REQUIRED_MESSAGE = 'Display time is required field';

export const ADVERTISEMENT_IMAGE_CONTROL = 'advertisement-image-control';
export const ADVERTISEMENT_IMAGE_REQUIRED_ERROR = 'ADVERTISEMENT_IMAGE_REQUIRED_ERROR';
export const ADVERTISEMENT_IMAGE_REQUIRED_MESSAGE = 'Banner is required field';

export const BANNER_IMAGE_CONTROL = 'banner-image-control';
export const BANNER_IMAGE_REQUIRED_ERROR = 'BANNER_IMAGE_REQUIRED_ERROR';
export const BANNER_IMAGE_REQUIRED_MESSAGE = 'Banner is required field';
